@if (!hasCreditNote()) {
  <elcia-card [title]="'invoice.step.preview' | translate">
    <div
      class="flex items-center justify-center h-96 border-2 border-dashed border-surface-200 rounded text-surface-400 italic">
      {{ 'invoice.preview-placeholder' | translate }}
    </div>
  </elcia-card>
} @else {
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
    <elcia-card [title]="'invoice.pdf' | translate">
      @if (isPdfLoading()) {
        <div class="flex items-center justify-center h-[75vh]">
          <elcia-loader/>
        </div>
      } @else if (isPdfError()) {
        <div class="flex items-center justify-center h-[75vh] text-surface-400 italic">
          {{ 'invoice.pdf-error' | translate }}
        </div>
      } @else if (pdfUrl()) {
        <iframe
          [src]="pdfUrl()"
          [title]="'invoice.pdf' | translate"
          class="w-full h-[75vh] rounded border border-surface-200"></iframe>
      }
    </elcia-card>

    <elcia-card [title]="'invoice.accounting-operations' | translate">
      @if (isAccountingLoading()) {
        <div class="flex items-center justify-center h-96">
          <elcia-loader/>
        </div>
      } @else if (operations().length === 0) {
        <p class="text-center py-4 text-surface-400 text-sm italic">
          {{ 'invoice.no-accounting-operations' | translate }}
        </p>
      } @else {
        <p-table [scrollable]="true" [size]="'small'" [value]="operations()" scrollHeight="flex">
          <ng-template #header>
            <tr>
              <th>{{ 'entity.accounting-account' | translate }}</th>
              <th class="text-right">{{ 'invoice.debit' | translate }}</th>
              <th class="text-right">{{ 'invoice.credit' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-op>
            <tr>
              <td>
                <div class="font-medium">
                  {{ op.accountingAccountName }}
                  @if (op.accountingAccountNumber) {
                    <span class="font-normal text-surface-400">({{ op.accountingAccountNumber }})</span>
                  }
                </div>
                <div class="text-xs text-surface-400 mt-0.5">{{ op.name }}</div>
              </td>
              <td class="text-right">{{ op.debit ? (op.debit | number: '1.2-2') + ' €' : '' }}</td>
              <td class="text-right">{{ op.credit ? (op.credit | number: '1.2-2') + ' €' : '' }}</td>
            </tr>
          </ng-template>
          <ng-template #footer>
            <tr class="font-semibold">
              <td>{{ 'invoice.total' | translate }}</td>
              <td class="text-right">{{ totalDebit() | number: '1.2-2' }} €</td>
              <td class="text-right">{{ totalCredit() | number: '1.2-2' }} €</td>
            </tr>
          </ng-template>
        </p-table>
      }
    </elcia-card>
  </div>
}
